var servicePathData = {};
if( window._serviceEnv.toUpperCase() == 'RC' ){
	servicePathData = {
		plaync : 'http://rc.kr.plaync.com/',
		cs : 'https://rc-cs.plaync.com/',
		nshop : 'https://rc-bnsnshop.plaync.com/bns/',
		nshopFr: "https://rc-bnsnshop.plaync.com/bnsr/",
		bns : 'https://rc-bns.plaync.com/',
		aion : 'https://rc-aion.plaync.com/',
		lineage : 'https://rc-lineage.plaync.com/',
		lineage2 : 'https://rc-lineage2.plaync.com/',
		lovebeat : 'http://rc.lovebeat.plaync.com/',
		bm : 'http://bm.plaync.com/',
		ha : 'http://ha.plaync.com/',
		rk : 'http://rc.rk.plaync.com',
		lineagem : 'http://rc.lineagem.plaync.com',
		mypage : 'https://rc-id.plaync.com/account/main',
		inquiry_list : 'https://rc-cs.plaync.com/inquiry/list/view',
		join: 'https://rc-id.plaync.com/member/agreement',
		nctalk: 'http://rc.nctalk.plaync.co.kr',
		ncoin: 'https://rc2-ncoin.plaync.com/ncoin/charge',
		npointL1: 'http://rc.nshop.plaync.com/nshop/my/npoint/save',
		gift: 'http://rc.nshop.plaync.com/nshop/ncoin/gift',
		inquiryList: 'https://rc-cs.plaync.com/inquiry/list',
		sandbox: 'https://rc-sandbox.plaync.com',
		powerbook : 'http://rc.bns.power.plaync.com/',
		esports : 'https://rc-bns.plaync.com/esports/main/',
		nctv : 'https://rc-nctv.plaync.com/',
		wstatic : 'https://rc-assets.playnccdn.com'
	}
} else {
	servicePathData = {
		plaync : 'http://kr.plaync.com/',
		cs : 'https://cs.plaync.com/',
		nshop : 'https://bnsnshop.plaync.com/bns/',
        nshopFr: "https://bnsnshop.plaync.com/bnsr/",
		bns : 'https://bns.plaync.com/',
		aion : 'https://aion.plaync.com/',
		lineage : 'https://lineage.plaync.com/',
		lineage2 : 'https://lineage2.plaync.com/',
		lovebeat : 'http://lovebeat.plaync.com/',
		bm : 'http://bm.plaync.com/',
		ha : 'http://ha.plaync.com/',
		rk : 'http://rk.plaync.com',
		lineagem : 'https://lineagem.plaync.com',
		mypage : 'https://id.plaync.com/account/main',
		inquiry_list : 'https://cs.plaync.com/inquiry/list/view',
		join: 'https://id.plaync.com/member/agreement',
		nctalk: 'http://nctalk.plaync.co.kr',
		ncoin: 'https://ncoin.plaync.com/ncoin/charge',
		npointL1: 'http://nshop.plaync.com/nshop/my/npoint/save',
		gift: 'http://nshop.plaync.com/nshop/ncoin/gift',
		inquiryList: 'https://cs.plaync.com/inquiry/list/view',
		sandbox: 'https://sandbox.plaync.com',
		powerbook : 'https://bns-power.plaync.com/',
		esports : 'https://bns.plaync.com/esports/main/',
		nctv : 'https://nctv.plaync.com/',
		wstatic : 'https://assets.playnccdn.com'
	};
	if (window._serviceEnv === 'SB') {
		servicePathData.bns = 'https://bns.sb.plaync.com/';
		servicePathData.wstatic = 'https://assets.sb.plaync.com';
	}
	if (window._serviceEnv === 'op') {
		servicePathData.bns = 'https://opdev-bns.plaync.com/';
		servicePathData.wstatic = ' https://op-assets.ncsoft.com';
	}

	if (location.href.match('local.bns.plaync.com:30454/')) {
		servicePathData.bns = "http://local.bns.plaync.com:30454/";
	}

	if (location.href.match('https://rwd-bns.plaync.com/')) {
		servicePathData.bns = "https://rwd-bns.plaync.com/";
	}

}

var bnsNshopLnbSub = [
	{
		"title": "N샵 메인",
		"url": servicePathData.nshop
	},
	{
		"title": "아이템",
		"url": servicePathData.nshop + "goods/list?dci=73"
	},
	{
		"title": "소울멤버십",
		"url": servicePathData.nshop + "goods/list?dci=74"
	},
	{
		"title": "부가서비스",
		"url": servicePathData.nshop + "goods/list?dci=75"
	},
	{
		"title": "포인트존",
		"url": servicePathData.nshop + "goods/list?dci=76&categoryType=point"
	}
];

if (_device=='ingame') {
	bnsNshopLnbSub.push({
		"title": "PC방 전용상품",
		"url": servicePathData.nshop + "pcbang"
	});
}

export const cnbConfig = {
	"type": "A",
	"bi": {
		"title": "Blade & Soul",
		"url": servicePathData.bns,
		"image": {
			top: {
				path : servicePathData.wstatic + '/uikit/cnb/v2/img/bi/bi-bns-type1.png',
				style : {
					width: 79,
					height: 46,
					marginTop: 2
				}
			},
			lnb: {
				path: servicePathData.wstatic + '/uikit/cnb/v2/img/bi/bi-bns-type2.png',
				style: {
					width: 79,
					height: 46,
					marginTop: 2
				}
			}
		}
	},
	"theme": {
		colorScheme: 'bns',
		/*colorScheme: {
			//name: ( _device == 'launcher') ? '' : 'bns',
			name: 'bns',
			start: '#ff5252',
			startOn: '#e54747',
			subMenu: {
				bar: '#7b8aff',
				hover: '#9ea9ff'
			}
		},
		style: {
			'#nc-cnb[data-theme=bns] .ncc-header, #nc-cnb[data-theme=bns] .ncc-left-panel-header': { backgroundColor: ( _device == 'launcher') ? '#192950' : '#343493' },
			'#nc-cnb .ncc-lnb .ncc-lnb-item__sub li a': { textShadow :'1px 1px 1px rgba(#fff, 0.3);'}
		} */
	},
	"activeSubUrls": ['/search/'],
	"useLeftMenu": true,
	"useLoginMenu": true,
	"useJoinMenu": true,
  "useCs":true,
  "csUrl":'https://help.plaync.com/faq/bns',
  "useCharInfoOnlyServer": true,
	"useGameStart": "gameStart",
	"gameStart": {
		"markUp": "<a href='"+ servicePathData.bns + "download/index' class='ncc-gamestart-btn__start'>다운로드</a>"
	},
	"mobileGameDown": {
		"showAndro": true,
		"showIos": true,
		"appName": "",
		"iosAppLink": "",
		"androAppLink": ""
	},
	"search": {
		"isShow": true,
		"destUrl": servicePathData.bns + "search/index",
		"queryPattern": "#",
		"service": "bns",
		"alias": "bns",
		"size": 10,
		"useDelbtn": true,
		"addParam": {}
	},
	"lnbData": [
		{
			"title": "소식",
			"url": servicePathData.bns + "board/notice/list",
			"iconType": "false",
			"sub": [
				{
					"title": "공지",
					"url": servicePathData.bns + "board/notice/list",
					"otherUrls" : ["board/notice/", ]
				},
				{
					"title": "업데이트",
					"url": servicePathData.bns + "board/update/list",
					"otherUrls" : ["board/update/"]
				},
				{
					"title": "업데이트 연대기",
					"url": servicePathData.bns + "history/list"
				},
        // {
        //   "title": "개발진의 방",
        //   "url": servicePathData.bns + "board/devletter/list",
        //   "otherUrls" : ["board/devletter/"]
        // },
        {
          "title": "포럼",
          "url": servicePathData.bns + "board/forum/list",
          "otherUrls" : ["board/forum/", "board/devletter/"]
        },
			]
		},
    {
      "title": "이벤트ON",
      "url": servicePathData.bns + "eventon"
    },
		{
			"title": "가이드",
			"url": servicePathData.bns + "guidebook/index",
      "iconType": 'new',
			"sub": [
				{
					"title": "가이드북",
					"url": servicePathData.bns + "guidebook/index",
          "iconType": 'new',
          "otherUrls" : ["guidebook"]
				},
				{
					"title": "초보자 가이드",
					"url": servicePathData.bns + "guide/beginner"
				},
				{
					"title": "PC방 혜택",
					"url": servicePathData.bns + "guide/pcbang"
				}
			]
		},
		{
			"title": "블소월드",
			"url": servicePathData.bns + "world/character",
			"sub": [
        {
          "title": "서고",
          "url": servicePathData.bns + "board/library/list",
          "otherUrls" : ["board/library/"]
        },
				{
					"title": "캐릭터",
					"url": servicePathData.bns + "world/character",
					"otherUrls": ["world/chatlog"]

				},
				{
					"title": "문파",
					"url": servicePathData.bns + "world/guild",
					"otherUrls": ["world/guildpr"]
				}
			]
		},
		{
			"title": "커뮤니티",
			"url": servicePathData.bns + "board/free/list",
			"sub": [
				{
				"title": "자유",
				"url": servicePathData.bns + "board/free/list",
				"otherUrls" : ["board/free/"]
				},
				{
					"title": "이벤트 참여",
					"url": servicePathData.bns + "board/event_participate/list",
					"otherUrls" : ["board/event_participate/"]
				},
				{
					"title": "직업",
					"url": servicePathData.bns + "board/job/list",
					"otherUrls" : ["board/job/"]
				},
        {
          "title": "연구",
          "url": servicePathData.bns + "board/knowhow/list",
          "otherUrls" : ["board/knowhow/", "board/tip/", "board/qna/"]

        },
				{
					"title": "파티모집/사고팔기",
					"url": servicePathData.bns + "board/party/list",
					"otherUrls" : ["board/party/", "board/market/", "board/member_recruit/"]
				},
				{
					"title": "이미지",
					"url": servicePathData.bns + "board/image/list",
					"otherUrls" : ["board/image/"]
				},
				{
					"title": "샌드박스",
					"url": servicePathData.sandbox,
					"iconType": ( _device == 'launcher') ? "external" : "false",
          "otherUrls":["sandbox.plaync.com"]
				}
			]
		},
		{
			"title": "블소N샵",
			"url": servicePathData.nshop,
			"sub": [
        // {
        //   title: "라이브N샵",
        //   url: servicePathData.nshop
        // },
				// {
				// 	title: "프론티어N샵",
				// 	url: servicePathData.nshopFr
				// }
			]
		},
		{
			"title": "NCTV",
			"url": servicePathData.nctv + "?tv=bns",
			"iconType": ( _device == 'launcher') ? "external" : "false",
			"sub": [
				{
					"title": "NCTV 메인",
					"url": servicePathData.nctv + "?tv=bns"
				},
				{
					"title": "인기영상",
					"url": servicePathData.nctv + "top?tv=bns"
				},
				{
					"title": "최신영상",
					"url": servicePathData.nctv + "recent?tv=bns"
				},
				{
					"title": "라이브",
					"url": servicePathData.nctv + "live?tv=bns"
				},
				{
					"title": "공략영상",
					"url": servicePathData.nctv + "attack/index?tv=bns"
				},
				{
					"title": "공식영상",
					"url": servicePathData.nctv + "official?tv=bns"
				},
				{
					"title": "e스포츠영상",
					"url": servicePathData.nctv + "esports?tv=bns"
				},
				{
					"title": "OST영상",
					"url": servicePathData.nctv + "ost?tv=bns"
				}
			]
		},
    {
      "title": "e스포츠",
      "url": servicePathData.bns + "esports/esportsvod/list",
      "iconType": "false",
      "sub": [
        {
          "title": "동영상",
          "url": servicePathData.bns + "esports/esportsvod/list",
        },
        {
          "title": "시즌 연대기",
          "url": servicePathData.bns + "esports/history",
        },
      ]
    }
	],
	"shortCut": {
		"isShow": true,
		"mypage": {
			"isShow": true,
			"type": "false",
			"popOption": "",
			"popupName": ""
		},
		"enterCoupon": {
			"type": "function",
			"name": "ncrwd.ncoin.openCouponPop"
		},
		"ncoin": {
			"isShow": false,
			"url": servicePathData.ncoin,
			"type": "popup",
			"popOption": "width=480,height=650,toolbar=0,menubar=0",
			"popupName": "ncoinPopup"
		},
		"cs": {
			"isShow": true,
			"type": "false",
			"popOption": "",
			"popupName": ""
		}
	},
  "serviceList": {
    "isServiceShow": true,
    "isGamesShow": true,
    "services": {
      "Plaync": {
        "isShow": true,
        "url": "https://www.plaync.com/"
      },
      "NShop": {
        "isShow": false,
        "url": "https://nshop.plaync.com/"
      }
    }
  },
	"appDownload": {
		"isShow": false,
		"appList": []
	},
	"loginFN": "GNBLogin",
	"logoutFN": "GNBLogout",
	"useCharChangeMenu": true,
	"charChangeFN": "characterChange",
	"showAccountName": true
}
